import React, { useMemo } from 'react';
import Tooltip2 from 'components/Common/Tooltip2';
import CalendarUtils from 'services/CalendarUtils';
import ReferralTrackingUtils from 'services/ReferralTrackingUtils';
import type { PatientDocument } from 'generated/api';
import './style.scss';

/**
 * "Referred to" — the referral half of the Consultants box in the staff CPP.
 *
 * Rows are derived read-only from the patient's referral documents (see
 * ReferralTrackingUtils), so they carry a date and a live status, which stored
 * consultant entries structurally cannot. Nothing here is editable: the source
 * of truth is the document, edited from the document itself.
 */
const CPPReferralsList = ({ documents }: { documents?: PatientDocument[] }) => {
  const rows = useMemo(() => ReferralTrackingUtils.getReferralRows(documents), [documents]);

  if (rows.length === 0) return null;

  return (
    <div className="cpp-referrals-list">
      <span className="small-title list-element">Referred to</span>
      <div className="list">
        {rows.map((row) => {
          const dateText = row.date ? CalendarUtils.format(row.date) : undefined;
          const label = row.specialty ? `${row.name} - ${row.specialty}` : row.name;

          const tooltip = (
            <div>
              <span>{label}</span>
              <br />
              <span>
                {row.statusLabel}
                {dateText ? ` — referred ${dateText}` : ''}
              </span>
            </div>
          );

          return (
            <Tooltip2 key={row.id} tooltip={tooltip}>
              {(register: any) => (
                <span
                  className={`tooltip-wrapper list-element truncate referral-row ${row.colorClass}`}
                  {...register}
                >
                  {label}
                  <span className="referral-status"> ({row.statusLabel})</span>
                </span>
              )}
            </Tooltip2>
          );
        })}
      </div>
    </div>
  );
};

export default CPPReferralsList;
